const BADGES = {
    "default": "grey-background-50",
    "error": "red-background-50",
    "succes": "success-background-50",
    "info": "primary-background-50",
    "gepauzeerd": "warning-background-50",
    "actief": "success-background-50",
    "inactief": "inactief-background",
    "afgerond": "primary-background-50",
    "none": "none"
}
const TEXT = {
    'default': "grey-600",
    "error": "red-500",
    "succes": "success-500",
    "info": "primary-500",
    "gepauzeerd": "warning-600",
    "actief": "success-500",
    "inactief": "inactief-color",
    "afgerond": "primary-700"

}

export function Badge({ label, rounded, badge, slim, style }) {
    return (
        <div data-testid={'badge1'} style={{ ...style, padding: (slim ? "0px 8px" : "") }} className={`badge ${(rounded) && 'rounded-badge standard-margin-bottom'} ${BADGES[badge]}`}>
            <p className={`xsmall-text bold-medium  ${TEXT[badge]}`}>{label}</p>
        </div>
    )
}


export const TailWindBadge = ({ children }) => {
    return <span className="inline-flex items-center rounded-xl bg-sky-100 px-3 py-1 text-sm font-semibold text-sky-700">
        {children}
    </span>
  
}



    export const Label = ({ children, className = "" }) => {
        return (
            <p className={`text-xs font-semibold uppercase tracking-wider text-slate-400 ${className}`}>
                {children}
            </p>
        );
    };

    export const Select = ({ value, onChange, options }) => {
        return (
            <select
                value={value}
                onChange={onChange}
                className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-sky-400"
            >
                {options.map((opt) => (
                    <option key={opt} value={opt}>
                        {opt}
                    </option>
                ))}
            </select>
        );
    };

    export const Toggle = ({ enabled, onToggle }) => {
        return (
            <button
                onClick={() => onToggle(!enabled)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${enabled ? "bg-sky-500" : "bg-slate-300"
                    }`}
            >
                <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${enabled ? "translate-x-5" : "translate-x-1"
                        }`}
                />
            </button>
        );
    };